let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("le1sE")).then(() => parcelRequire('7DdDO'));